import React from 'react';

export const ImageSet = () => (
    <g>
        <path d='M19,18.5v-17C19,1.224,18.776,1,18.5,1h-17C1.224,1,1,1.224,1,1.5v17C1,18.776,1.224,19,1.5,19h17
			C18.776,19,19,18.776,19,18.5z M18,2v13h-2.161l-2.875-7.186c-0.075-0.186-0.252-0.31-0.453-0.314
			c-0.198,0.01-0.384,0.111-0.467,0.293l-2.17,4.775l-1.99-2.389c-0.104-0.124-0.265-0.191-0.423-0.178
			c-0.162,0.013-0.307,0.103-0.39,0.241L4.217,15H2V2H18z M14.762,15H5.383l2.184-3.639l2.049,2.459
			c0.11,0.133,0.277,0.198,0.451,0.175c0.17-0.022,0.317-0.132,0.388-0.289l2.016-4.434L14.762,15z M2,18v-2h16v2H2z' />
        <path d='M22.884,7.242c-0.085-0.102-0.207-0.166-0.339-0.178l-1.992-0.181c-0.273-0.023-0.518,0.178-0.543,0.453
			s0.178,0.518,0.453,0.543l1.494,0.136l-1.272,13.942L6.245,20.639c-0.275-0.028-0.518,0.178-0.543,0.453
			c-0.025,0.275,0.178,0.519,0.453,0.543l14.938,1.363C21.106,23,21.122,23,21.137,23c0.116,0,0.23-0.041,0.32-0.116
			c0.102-0.085,0.166-0.207,0.178-0.338l1.363-14.939C23.01,7.475,22.969,7.343,22.884,7.242z' />
        <path d='M6,8c1.103,0,2-0.897,2-2S7.103,4,6,4S4,4.897,4,6S4.897,8,6,8z M6,5c0.551,0,1,0.449,1,1S6.551,7,6,7S5,6.551,5,6
			S5.449,5,6,5z' />
    </g>
);